import { NgModule } from '@angular/core';
import { DecentralizeDirective } from './decentralization.directive';
import { DecentralizeRootDirective } from './decentralizationRoot.directive';
@NgModule({
  declarations: [DecentralizeDirective, DecentralizeRootDirective],
  exports: [DecentralizeDirective, DecentralizeRootDirective]
})
export class DecentralizationModule { }
